import React, { useState, useContext } from 'react';
import { NotificationsContext } from '@ui-components/Notifications';
import Spinner from '@ui-components/Spinner';

/*
DocumentInfoComponent is a component that shows the info of a document
parameters: documentInfoPromise -> a promise that resolves to the info of the document
the props is a promise because the info of the document may be fetched from the server (through an api call to S3)
until the promise resolves a spinner is shown instead of the info of the document
 */
const DocumentInfoComponent = ({ documentInfoPromise }) => {
	const [loading, setLoading] = useState(true);
	const [documentInfo, setDocumentInfo] = useState(null);
	const { push } = useContext(NotificationsContext);

	documentInfoPromise.then((res) => {
		setLoading(false);
		setDocumentInfo(res)
	}).catch((e) => {
		setLoading(false);
		push({ type: 'error', title: e.message });
	});

	return (
		<div>
			{
				loading ?
					<div className={"flex gap-x-4"}>
						<div className={"relative w-5 h-5"}>
							<Spinner spinnerColor={"#000000"} />
						</div>
						<p>loading info...</p>
					</div>
					: documentInfo
			}
		</div>
	);
}


export default DocumentInfoComponent;